import React, { useEffect, useState } from "react";
import axios from "axios";
import url from "../../services/url";
import { If } from "react-condition";
import { useHistory } from "react-router-dom";
import Loginimg from "../../images/Maxicus_logo.png";
function UserResetPassword() {
  const [alert, setAlert] = useState("");
  const [EmailValue,setEmailValue] = useState("")
  const [error,SetError] = useState("")
  const [Color,SetColor] = useState(true);
  const [CheckEmail,setCheckEmail] = useState("")
  const [EmailShow,setEmailShow] = useState(false)

  const history = useHistory();

  const Validate=()=>{
      let EmailError="";
      let filter = /^([a-zA-Z0-9_.-])+\@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
      if (filter.test(EmailValue)) {
        // Yay! valid
        return true

      }
      else{
         setCheckEmail("InValid Email");
         setEmailShow(true)
         return false
      }
  }

  const ResetPassword=async(e)=>{
      e.preventDefault();
      const isValid =  Validate();
       console.log(isValid);
      if(isValid){
    // const response = await fetch("http://172.17.103.25:4001/api/candidates/resetPassword",{
        const response = await fetch(url("user/resetpassword"),{
        method: "POST" ,
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            emailId:EmailValue
        })
    })
    const res=await response.json()
     //console.log(response.status)
    console.log(res)
     if(response.status === 200){
         if(res.message!=null)
         {
            SetError(res.message)
            setEmailShow(false)
            setEmailValue("")
            SetColor(false)
         }
         else
         {
            SetError("Invalid Response")
         }
        }
        else{
            SetError(res.error);
            setEmailShow(false)
        }

     }
  }

  return (
    <div className="container bg-white">
      <div className="row justify-content-center">
        <div className="col-xl-10 col-lg-12 col-md-9">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-lg-6 d-none d-lg-block bg-login-image"></div>
                <div className="col-lg-6">
                  <div className="p-5">
                    <div className="text-center">
                      <img src={Loginimg} alt="Login" className="mb-1" />
                      <small className="app-name">Digital Hiring</small>
                      <hr />
                      <h1 className="h4 text-gray-900 mb-4">Reset Password </h1>
                      {!EmailShow && <p style={Color ? { color:'red'} : { color:'green'} }>{error}</p>}
                      {EmailShow && <p style={{color:'red'}}>{CheckEmail}</p>}
                    </div>
                    <If test={alert !== ""}>
                      <div className="alert alert-danger">{alert}</div>
                    </If>
                    <form className="user" method="post">
                      <div className="form-group">
                        <input
                          type="email"
                          value={EmailValue}
                          className="form-control form-control-user"
                          onChange={(e)=>setEmailValue(e.target.value)}
                          placeholder="Enter Email Address..."
                        />
                      </div>
                      
                      <button
                      disabled={!EmailValue}
                        className="btn btn-primary btn-user btn-block"
                        onClick={ResetPassword}
                      >
                        Send Link
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserResetPassword;

